import injectSheet from 'react-jss';
import * as React from 'react';
import { Modal, Table, Input } from 'antd';
import { useState } from 'react';
import { StylesProps } from 'src/Library/Types';
import { RfqBidDetailsType } from '../../../SE.interfaces';

const Search: any = Input.Search;

const styles = (theme: any) => ({
  title: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#424242',
  },
  table: {
    marginTop: '24px',
    borderRadius: '2px 2px 0 0',
    background: '#fff',
    border: '1px solid #E8E8E8',
    '& td': {
      verticalAlign: 'baseline',
    },
    '& .ant-table-thead': {
      fontSize: '14px',
      whiteSpace: 'pre-line !important',
      backgroundColor: '#f5f5f5',
      color: '#424242',
      padding: 0,
    },
    '& .ant-table-thead > tr > th, .ant-table-tbody > tr > td': {
      borderRight: '1px solid #E8E8E8',
    },
  },
  flexBox: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  search: {
    width: '20%',
  },
  textCol: {
    color: '#262626',
  },
  firstCol: {
    backgroundColor: '#F5F5F5',
    borderRight: '1px solid #E8E8E8',
    color: '#262626',
    fontWeight: 600,
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '15px',
    marginRight: '15px',
  },
});

interface RfqBidDetailsModalProps extends StylesProps<ReturnType<typeof styles>> {
  onClose: () => void;
  visible: boolean;
  bidDetails: RfqBidDetailsType[];
}

const RfqBidDetailsModal: React.FunctionComponent<RfqBidDetailsModalProps> = ({
  visible,
  onClose,
  classes,
  bidDetails
}) => {
  let searchRef: any;
  const [dataSource, setDataSource] = useState(bidDetails);

  const handleSearchTextChange = (searchText) => {
    if (!searchText) {
      setDataSource(bidDetails);
      return;
    }
    const filteredDetails = bidDetails.filter((bidDetail: any) =>
      bidDetail.label?.toLowerCase().includes(searchText.toLowerCase()),
    );
    setDataSource(filteredDetails);
  }

  const columns = [
    {
      title: '',
      dataIndex: 'label',
      key: 'label',
      className: classes.firstCol,
      width: 200,
    },
    {
      title: '',
      dataIndex: 'value',
      key: 'value',
      render: (data) => {
        if (!data) {
          return '';
        }
        if (typeof data === 'object') {
          return `${data.currency} ${data.amount}`;
        }
        return data;
      }
    }
  ];

  const renderSearchBox = () => {
    return (
      <div className={classes.flexContainer}>
        <div className={classes.flexBox}>
          <Search
            className={classes.search}
            placeholder={'Search'}
            onChange={e => handleSearchTextChange(e.target.value)}
            ref={ref => searchRef = ref}
          />
        </div>
      </div>
    );
  }

  return (
    <Modal
      title={<div className={classes.title}>{'Detail View'}</div>}
      bodyStyle={{ paddingLeft: '0px', paddingRight: '0px', paddingTop: '24px' }}
      maskClosable={false}
      centered
      style={{ minWidth: '85%', marginTop: 0 }}
      onOk={() => { }}
      onCancel={() => onClose()}
      visible={visible}
      footer={null}
      destroyOnClose={true}>
      {renderSearchBox()}
      {<Table
        pagination={false}
        showHeader={false}
        columns={columns}
        className={classes.table}
        style={{marginTop: '24px'}}
        dataSource={dataSource &&
          dataSource.length ? dataSource : []}
      />}
    </Modal>
  );
}

export default injectSheet(styles)(RfqBidDetailsModal);
